import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import path from 'path';
import { Heading4 } from '@latitude/heading';
import {
  ALIGN,
  BUTTON_STYLE,
  COLOR,
  MARGIN
} from '@latitude/core/utils/constants';
import CardNews from './_CardNews';
import MediaFeatured from './MediaFeatured';
import Section from '../Section/Section';
import './_media.scss';
import featuredImage from '../../templates/media/images/webjet.webp';

const Anchor = styled.div`
  width: 0;
  height: 0;
  position: relative;
  top: -30px;
`;

const MediaList = () => {
  const data = useStaticQuery(
    graphql`
      query {
        mediaReleases: allMarkdownRemark(
          filter: {
            fileAbsolutePath: { glob: "**/src/templates/media/releases/*.md" }
          }
          sort: { fields: [frontmatter___date], order: DESC }
        ) {
          edges {
            node {
              fileAbsolutePath
              excerpt(pruneLength: 200)
              frontmatter {
                title
                date(formatString: "D MMMM YYYY")
                trackId
                heroBg
                image {
                  publicURL
                }
                pathoverride
              }
            }
          }
        }
      }
    `
  );

  const allMediaReleases = data.mediaReleases.edges.map(edge => {
    const { fileAbsolutePath, excerpt, frontmatter } = edge.node;
    const { title, date, trackId, image, publicURL, pathoverride } = frontmatter;
    const markdownFileNameWithoutExtension = path.basename(
      fileAbsolutePath,
      path.extname(fileAbsolutePath)
    );

    return {
      path: pathoverride == null ? `/about-us/media-releases/${markdownFileNameWithoutExtension}.html` : pathoverride,
      title,
      date,
      excerpt,
      trackId,
      image,
      publicURL
    };
  });

  return (
    <>
      <Section className="bg-lightest">
        <Anchor id="featured-stories" />
        <Heading4
          color={COLOR.BLACK}
          align={ALIGN.CENTER}
          marginTop={MARGIN.M48}
          marginBottom={MARGIN.M48}
        >
          Featured
        </Heading4>
        <MediaFeatured
          imageProps={{
            src: [featuredImage],
            alt: allMediaReleases[0].title,
            href: allMediaReleases[0].path
          }}
          titleProps={{
            title: allMediaReleases[0].title,
            isGreyBg: true,
            maxLines: 3,
            textAlign: 'left'
          }}
          date={allMediaReleases[0].date}
          // The business wants the summary to stop at the first sentence:
          // description="Latitude Financial acknowledges ASIC's filing of civil proceedings regarding alleged misleading advertising of Latitude GO Mastercard&reg;."
          // Otherwise, use this:
          description={allMediaReleases[0].excerpt}
          maxLine="5"
          buttonProps={{
            button: BUTTON_STYLE.SECONDARY,
            href: allMediaReleases[0].path,
            trackId: allMediaReleases[0].trackId,
            btnText: 'Read more'
          }}
        />
      </Section>
      <Section className="bg-white">
        <Anchor id="past-stories" />
        <Heading4
          color={COLOR.BLACK}
          align={ALIGN.CENTER}
          marginBottom={MARGIN.M48}
        >
          Past Stories
        </Heading4>
        <div className="media-list">
          {allMediaReleases.map(
            ({ path, title, excerpt, trackId, image, date }) => (
              <div className="media-list-item" key={path}>
                <CardNews
                  imageProps={{
                    src: image.publicURL,
                    href: path,
                    alt: title
                  }}
                  titleProps={{ title, isGreyBg: true, maxLines: '2' }}
                  date={date}
                  description={excerpt}
                  maxLines="3"
                  buttonProps={{
                    href: path,
                    trackId,
                    btnText: 'Read more'
                  }}
                />
              </div>
            )
          )}
        </div>
      </Section>
    </>
  );
};

export default MediaList;
